module.exports = __webpack_public_path__ + "static/media/checked-blue.07d30b77.svg";